import React, { useState } from 'react';

const PermissionModal = ({ isOpen, setIsOpen, onCreate }) => {
  const [permissionName, setPermissionName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (permissionName.trim()) {
      setLoading(true);
      setError('');
      try {
        await onCreate(permissionName.trim());
        setPermissionName('');
        setIsOpen(false);
      } catch (err) {
        setError(err.message || "Erreur lors de la création");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={() => setIsOpen(false)}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300"
        onClick={e => e.stopPropagation()}
      >
        <div className="bg-gradient-to-r from-[#5e17eb] to-[#7c3aed] px-6 py-4 rounded-t-2xl">
          <h2 className="text-2xl font-bold text-white text-center">Ajouter une Permission</h2>
        </div>
        
        <form className="p-6" onSubmit={handleSubmit}>
          <div className="mb-6">
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Nom de la Permission
            </label>
            <input
              type="text"
              value={permissionName}
              onChange={(e) => setPermissionName(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#5e17eb] focus:ring-2 focus:ring-[#5e17eb]/30 transition-all duration-200"
              placeholder="Ex: view_users, create_meeting..."
              disabled={loading}
              autoFocus
            />
          </div>
          
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
              {error}
            </div>
          )}
          
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="px-5 py-2.5 bg-gray-200 text-gray-700 rounded-xl hover:bg-gray-300 transition-all duration-200 font-medium"
              disabled={loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="px-5 py-2.5 bg-gradient-to-r from-[#5e17eb] to-[#7c3aed] text-white rounded-xl hover:from-[#7c3aed] hover:to-[#5e17eb] transition-all duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed shadow-md"
              disabled={loading || !permissionName.trim()}
            >
              {loading ? 'Création...' : 'Ajouter'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PermissionModal;